import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import type { Testimonial } from '../data/testimonials';
type TestimonialsProps = {
  testimonials: Testimonial[];
  title?: string;
  subtitle?: string;
  background?: 'white' | 'blush';
};
export function Testimonials({
  testimonials,
  title = 'What activity professionals are saying',
  subtitle,
  background = 'white'
}: TestimonialsProps) {
  const bg = background === 'white' ? 'bg-white' : 'bg-blush';
  // Avoid an orphan card: 3 columns only when the count divides evenly.
  const desktopCols = testimonials.length % 3 === 0 ? 'lg:grid-cols-3' : '';
  return <section aria-label={title} className={`w-full text-ink ${bg}`} data-id="element-268" data-mp="2x1kzar0m4lw6">
      <div className="mx-auto max-w-5xl px-5 py-16 sm:py-20" data-id="element-269" data-mp="2s28e0ape3mvp">
        <div className="text-center" data-id="element-270" data-mp="2s3tai5v9lfw7">
          <p className="text-[13px] font-semibold text-gold-deep" data-id="element-271" data-mp="v9yex8b87p8o">
            Activity professional to activity professional
          </p>
          <h2 className="mt-3 font-display text-3xl font-bold text-ink sm:text-5xl" data-id="element-272" data-mp="qav9hmrc3h06">
            {title}
          </h2>
          {subtitle && <p className="mx-auto mt-4 max-w-2xl text-sm text-ink-soft" data-id="element-273" data-mp="m4rnqbjn1c5w">
              {subtitle}
            </p>}
        </div>

        <div className={`mt-9 grid gap-4 sm:mt-12 sm:grid-cols-2 sm:gap-5 ${desktopCols}`} data-id="element-274" data-mp="7926srtb7p81">
          {testimonials.map(item => <figure key={item.author} className="flex flex-col rounded-3xl border border-cream-line bg-cream p-6 sm:p-7" data-id="element-275" data-mp="c8oll5osddiy">
              <div className="flex items-center justify-between" data-id="element-276" data-mp="14u7pt3az1cof">
                <QuoteIcon className="h-6 w-6 fill-gold/30 text-gold-deep" aria-hidden="true" data-id="element-277" data-mp="q764mq3qy1uj" />
                {item.rating ? <span className="flex gap-0.5" aria-label={`${item.rating} out of 5`} data-id="element-278" data-mp="1ivadtllj0x1z">
                    {Array.from({
                length: item.rating
              }).map((_, s) => <StarIcon key={s} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-279" data-mp="1xi90z4dcp5aw" data-mpi={s} />)}
                  </span> : null}
              </div>

              <blockquote className="mb-6 mt-4 font-display text-[17px] leading-relaxed text-ink sm:text-lg" data-id="element-280" data-mp="1jir74al771uo">
                “{item.quote}”
              </blockquote>

              <figcaption className="mt-auto flex items-center gap-3 border-t border-cream-line pt-5" data-id="element-281" data-mp="1ekzhxobxttu6">
                {item.avatar ? <img src={item.avatar} alt={item.author} width={48} height={48} loading="lazy" className="h-12 w-12 flex-none rounded-full object-cover ring-2 ring-white" data-id="element-282" data-mp="14sjzyr0n559a" /> : <span aria-hidden="true" className="flex h-12 w-12 flex-none items-center justify-center rounded-full bg-plum font-display text-[15px] font-semibold text-gold-hover" data-id="element-283" data-mp="qu2cmuendurw">
                    {initials(item.author)}
                  </span>}
                <span className="min-w-0" data-id="element-284" data-mp="3cd8vh6ieie40">
                  <span className="block text-[15px] font-semibold text-ink" data-id="element-285" data-mp="3gfnje50xg425">
                    {item.author}
                  </span>
                  <span className="block text-[13px] text-ink-soft" data-id="element-286" data-mp="2jobhhfl833h2">
                    {item.role}
                  </span>
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}
function initials(name: string) {
  return name.replace(/[^A-Za-z ]/g, '').split(' ').filter(Boolean).map(w => w[0]).join('').slice(0, 2).toUpperCase() || 'MC';
}